import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";
import { matrixConfigSchema, type MatrixConfig } from "./matrixCommon.js";

/** Rows × columns, any number of answers per row. Stored as `{ [rowKey]: columnValue[] }`. */
export const matrixCheckboxField: FieldDescriptor<MatrixConfig> = {
  type: "matrix_checkbox",
  label: "Matrix (multiple answers per row)",
  category: "matrix",
  icon: "Grid2x2Check",
  configSchema: matrixConfigSchema,
  valueSchema: (config, isRequired) => {
    const columnValues = config.columns.map((column) => column.value);
    const cell = z
      .array(z.string())
      .refine(
        (values) =>
          columnValues.length === 0 || values.every((value) => columnValues.includes(value)),
        "One or more selections are not valid for this row",
      );

    const shape: Record<string, z.ZodTypeAny> = {};
    for (const row of config.rows) {
      shape[row.key] =
        isRequired || config.requireAllRows
          ? cell.refine((values) => values.length > 0, "Select at least one option in each row")
          : cell.optional();
    }

    return optionalUnlessRequired(z.object(shape).strict(), isRequired);
  },
  defaultConfig: { rows: [], columns: [], requireAllRows: false },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isComposite: true },
};
